module.exports = __webpack_public_path__ + "img/dhsxjh.1966448a.png";